// extracted by mini-css-extract-plugin
export default {"verticalGapContainer":"FullNameField-module--verticalGapContainer--LbPl8","horizontalGapContainer":"FullNameField-module--horizontalGapContainer--wbpf4"};